export default __webpack_public_path__ + "static/media/xmark-circle.425fbce1.svg";